import React from "react";
import styled from "styled-components";
import { Item } from "@radix-ui/react-accordion";
const StyledAccordionItem = ({ children, ...componentProps }) => (React.createElement(Item, { ...componentProps }, children));
StyledAccordionItem.defaultProps = {
    "data-testid": "accordion-item",
};
export const AccordionItem = styled(StyledAccordionItem) ``;
//# sourceMappingURL=AccordionItem.js.map